import { graphHooks } from '@tunasong/graph-lib/react'
import type { FC } from 'react'
import { EntityLink } from '../entity/entity-link.js'
import { HBox } from '../layout/horizontal-box.js'
import EmptyLinks from './empty-links.js'
import { entitySort } from '@tunasong/models'
import { LinearProgress } from '../primitives/index.js'

export interface BacklinksProps {
  id?: string
}

export const Backlinks: FC<BacklinksProps> = ({ id = '' }) => {
  const { backlinks = [] } = graphHooks.useEntityBacklinks({ entityId: id })

  const ids = backlinks
    .map(backlink => backlink.source)
    .filter(id => id !== 'ROOT')
    .filter(Boolean)

  const { entities: linkedEntities = [], isLoading } = graphHooks.useEntitiesById(ids)
  const entities = entitySort({ entities: linkedEntities })

  return (
    <div>
      {isLoading ? <LinearProgress /> : null}

      {entities.map(entity => {
        const backlink = backlinks.find(backlink => backlink.source === entity.id)
        return entity ? (
          <HBox key={entity.id} style={{ justifyContent: 'space-between' }}>
            <EntityLink entity={entity} />
            <div>[{backlink?.relation}]</div>
          </HBox>
        ) : null
      })}
      {backlinks.length === 0 ? <EmptyLinks text="No backlinks" /> : null}
    </div>
  )
}

export default Backlinks
